import type { Session } from '#src/shared/session';

/**
 * Whether a session may vault a payment method on its account: authenticated users, and guests that
 * will be turned into a real user before paying. Identified sessions (email-link visitors) and secure
 * guests cannot.
 */
export function canSavePaymentMethod(loginState: Session['loginState'], doubleOptinEnabledNewUser: boolean): boolean {
	if (loginState === 'AUTHENTICATED') return true;
	return loginState === 'GUEST' && !doubleOptinEnabledNewUser;
}
